function EnableDisableTextBox(myRadio) {
  let radios = document.querySelectorAll('#ProductSelect-option-0 input');
  if(radios.length <= 4 )
  {
  	let inputs = document.querySelectorAll('#infiniteoptions-container input');

      for (let i = 0; i < inputs.length; i++)
      {
        inputs[i].removeAttribute("disabled");
        if(i >= myRadio)
        {
          inputs[i].setAttribute("disabled", "disabled");
        }
      }
  }
}



function DisableTextBox() {
  	let radios = document.querySelectorAll('#ProductSelect-option-0 input');
  	if(radios.length <= 4 )
    {
      let inputs = document.querySelectorAll('#infiniteoptions-container input');
      for (let i = 1; i < inputs.length; i++)
      {
        inputs[i].setAttribute("disabled", "disabled");
      }
    }
}

function obs(mutationList, observer){
  DisableTextBox();
}

if(document.getElementById('ProductSelect-option-0'))
{
  	let container = document.querySelector('#infiniteoptions-container');
	const observer = new MutationObserver(obs);
	observer.observe(container, {attributes: true, childList: true, characterData: true});
}
